import api from '../../Services/api';
import { LoginResponse, SignInData } from './interfaces';
import globals from './../../Globals.json';

const TOKEN_KEY = '@token';
const ID_KEY = '@id';
const TOKEN_EXPIRATION = '@token_expiration';
const EXPIRATION_TIME = 20 * 24 * 60 * 60 * 1000; // 20 dias em milissegundos

export class LoginApi {
  private static instance: LoginApi;

  public static getInstance(): LoginApi {
    if (!LoginApi.instance) {
      LoginApi.instance = new LoginApi();
    }
    return LoginApi.instance;
  }

  async auth(data: SignInData) {
    try {
      const response = await api.post<LoginResponse>(globals.api.login, data);

      if ((response as any)?.response?.data.error) {
        throw (response as any).response.data.error;
      }

      // Define o token no cabeçalho padrão das requisições
      api.defaults.headers[
        'Authorization'
      ] = `Bearer ${response.data.access_token}`;

      // Define tempo de expiração
      const expirationTime = Date.now() + EXPIRATION_TIME;

      // Salva os dados no localStorage
      response.data.access_token &&
        localStorage.setItem(TOKEN_KEY, response.data.access_token);
      localStorage.setItem(TOKEN_EXPIRATION, expirationTime.toString());

      response.data.user &&
        localStorage.setItem('user', JSON.stringify(response.data.user));

      response.data.user.relationships.stores[0] &&
        localStorage.setItem(
          'acitvedStore',
          JSON.stringify(response.data.user.relationships.stores[0])
        );

      return response.data as LoginResponse;
    } catch (err: any) {
      if (err?.response?.data?.error) {
        throw err.response.data.error;
      }

      throw err;
    }
  }
}
